<wiz-hgroup #actionContainer height="100%" verticalAlign="center" horizontalAlign="end" width="100%">
    <!-- On utilise le click pour pouvoir faire un prevent -->
    <wiz-icon *ngIf="canAdd()" (click)="doAdd($event)" [wizTooltip]="'$.common.addchild.$'" >add</wiz-icon>
    <wiz-icon *ngIf="canEdit()" (click)="doEdit($event)" [wizTooltip]="'$.common.edit.$'" >edit</wiz-icon>
    <wiz-spacer *ngIf="!canEdit()" width="20px" height="20px"></wiz-spacer>
    <wiz-icon *ngIf="canDelete()" (click)="doDelete($event)" [wizTooltip]="'$.common.delete.$'" >close</wiz-icon>
    <wiz-spacer *ngIf="!canDelete()" width="20px" height="20px"></wiz-spacer>
</wiz-hgroup>